(() => {
  const bar = document.querySelector('[data-ga-mobile-contact]');
  if (!bar) return;
  document.body.classList.add('ga-has-mobile-contact');
  const update = () => {
    const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    bar.hidden = window.scrollY < 250 || editing || window.innerWidth > 749;
  };
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update, {passive:true});
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => queueMicrotask(update));
  update();
})();
